module.exports = __webpack_public_path__ + "img/dikidi.cf4e3f4b.png";